import Api from "./base/api-base";

export default class AuthApi {
  login(params) {
    return Api.post({
      endpoint: Api.endpoint.login,
      params: params
    });
  }

  logout() {
    return Api.get({
      endpoint: Api.endpoint.logout
    });
  }
}